import React from 'react';
import Stack from '@mui/material/Stack';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import MyAlert from '../common/components/MyAlert';
import {MyTypography} from '../common/components';

export default function OcrAnnotation({children, title, severity='info'}) {
    return (
        <MyAlert
            severity={severity}
            icon={false}
            title={
                <Stack direction="row"
                       alignItems="flex-start"
                       spacing={1}>
                    <DocumentScannerIcon fontSize="small" />
                    <MyTypography variant="subtitle1">{title}</MyTypography>
                </Stack>
            }
        >
            {children}
        </MyAlert>
    );
}
